import type { AngelouCSS, AnchorStyleOverrides } from "@newsela/angelou";

export const skipToAnchorCss: AnchorStyleOverrides<AngelouCSS> = {
  root: {
    padding: "0.75rem 0",

    ":active, :focus": {
      "> div": {
        width: "48px",
        opacity: 1,
        height: "1.5rem",
        alignItems: "center",
        fontSize: "0.85rem",
      },
    },

    "> div": {
      width: "0px",
      opacity: 0,
      fontSize: "0.85rem",
    },

    "@media (max-width: 380px)": {
      display: "none",
    },
  },
};
